import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "m-0" }
const _hoisted_3 = ["id", "aria-controls", "aria-expanded"]
const _hoisted_4 = { class: "min-w-0 flex-1" }
const _hoisted_5 = { class: "block text-[15px] font-semibold text-catering-ink-900" }
const _hoisted_6 = ["id", "aria-labelledby"]

import { CheckIcon, ChevronDownIcon } from '@heroicons/vue/24/solid'
import { computed } from 'vue'

// Without an entry here the fallback is todo's grey, which is what "Not seen
// yet" wears - so the one state asking the merchant for something would read as
// the one asking them for nothing until they expanded the step.

export default {
  __name: 'SetupStep',
  props: {
  stepKey: { type: String, required: true },
  index: { type: Number, required: true },
  title: { type: String, required: true },
  status: { type: String, default: '' },
  tone: { type: String, default: 'todo' },
  complete: { type: Boolean, default: false },
  open: { type: Boolean, default: false }
},
  emits: ['toggle'],
  setup(__props) {

const TONE_CLASSES = {
  done: 'text-catering-herb-600',
  pending: 'text-catering-honey-600',
  attention: 'text-catering-tomato-600',
  todo: 'text-catering-ink-500'
}

const props = __props


const statusClass = computed(() => TONE_CLASSES[props.tone] || TONE_CLASSES.todo)

const markerClass = computed(() => {
  if (props.complete) return 'border-catering-ink-900 bg-catering-ink-900 text-catering-lemon'
  if (props.open) return 'border-catering-ink-900 bg-catering-lemon text-catering-ink-900'
  return 'border-catering-cream-500 bg-catering-cream-200 text-catering-ink-400'
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `setup-step-${__props.stepKey}`,
    class: _normalizeClass(["overflow-hidden rounded-catering-lg border bg-catering-cream-50 transition-colors", __props.open ? 'border-catering-ink-900 shadow-catering-md' : 'border-catering-cream-400 shadow-catering-xs'])
  }, [
    _createElementVNode("h3", _hoisted_2, [
      _createElementVNode("button", {
        id: `setup-step-header-${__props.stepKey}`,
        type: "button",
        class: "flex w-full items-center gap-3 bg-transparent p-4 text-left font-catering-body focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-catering-ink-900",
        "aria-controls": `setup-step-panel-${__props.stepKey}`,
        "aria-expanded": __props.open,
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('toggle')))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["grid h-7 w-7 flex-shrink-0 place-items-center rounded-full border-[1.5px] font-catering-mono text-xs transition-colors", markerClass.value])
        }, [
          (__props.complete)
            ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                key: 0,
                class: "h-4 w-4",
                "aria-hidden": "true"
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(__props.index), 1)
              ], 64))
        ], 2),
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.title), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["mt-0.5 block text-xs", statusClass.value])
          }, _toDisplayString(__props.status), 3)
        ]),
        _createVNode(_unref(ChevronDownIcon), {
          class: _normalizeClass(["h-4 w-4 flex-shrink-0 text-catering-ink-400 transition-transform duration-200 motion-reduce:transition-none", __props.open && 'rotate-180']),
          "aria-hidden": "true"
        }, null, 8, ["class"])
      ], 8, _hoisted_3)
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "transition duration-200 ease-out motion-reduce:transition-none",
      "enter-from-class": "-translate-y-1 opacity-0",
      "leave-active-class": "transition duration-150 ease-in motion-reduce:transition-none",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (__props.open)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: `setup-step-panel-${__props.stepKey}`,
              role: "region",
              "aria-labelledby": `setup-step-header-${__props.stepKey}`,
              class: "border-t border-catering-cream-400 px-4 pb-5 pt-1"
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 8, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 10, _hoisted_1))
}
}

}